import gql from "graphql-tag";

export default gql`
  fragment BrazilianCompanyIssuerHoverCardFields on BrazilianCompanyIssuer {
    _id
    name
    tickerSymbolPrefix
    primaryTickerSymbol
    businessDescription
    isBrazilianDepositaryReceipt
    sector
    niceLogo {
      url
    }
    marketCapitalization {
      asOfDate
      totalCapitalization
    }
  }

  fragment AmericanCompanyIssuerHoverCardFields on AmericanCompanyIssuer {
    _id
    name
    primaryTickerSymbol
    businessDescription
    isAmericanDepositaryReceipt
    sector
    niceLogo {
      url
    }
    marketCapitalization {
      asOfDate
      totalCapitalization
    }
  }

  fragment BrazilianRealEstateFundHoverCardFields on BrazilianRealEstateFund {
    _id
    name
    tickerSymbol
    shortDescription
    selfRegulation {
      primarySegment
    }
    marketCapitalization {
      asOfDate
      totalCapitalization
    }
  }
`;
